// 賠付表（每線下注的倍率）— 對應 Unity PayTableSO。
// 真實數值待從後端/Unity 取得；此處為開發用合成值，供 MockSpinService 計算。
// key = 符號 ID；陣列索引 = (連續符號數 - 3)，即 3 連、4 連、5 連、6 連的倍率。

const ODDS: Readonly<Record<number, readonly number[]>> = {
  0: [0, 0, 0, 0], // Wild 本身不單獨計獎
  1: [20, 50, 200, 500], // H1
  2: [15, 40, 150, 400], // H2
  3: [10, 30, 100, 300], // H3
  4: [8, 20, 60, 150], // LA
  5: [6, 15, 40, 100], // LK
  6: [4, 10, 30, 80], // LQ
  7: [2, 8, 25, 60], // LJ
}

/**
 * 取得某符號連續 n 個的每線倍率（n 為實際連續符號數，>=3 才有獎）。
 */
export function lineOdds(symbol: number, symbolRunLength: number): number {
  if (symbolRunLength < 3) return 0
  const table = ODDS[symbol]
  if (table === undefined) return 0
  const index = Math.min(symbolRunLength - 3, table.length - 1)
  return table[index]
}
